import { useDevServerLogs } from '@/api-models/dev-server';
import { Spinner } from '@/ui/Spinner';

/**
 * The dev server's recent output, collapsed by default.
 *
 * Mounted only while the disclosure is open, which is the whole point: the fetch behind it goes
 * through `ensure_session_sandbox_live`, so an always-on log poll would be a second stream keeping
 * the sandbox awake for output nobody is reading.
 */
export function DevServerLogs({ base }: { base: string }) {
  const { logs, error, isLoading } = useDevServerLogs(base, true);

  if (isLoading && !logs) {
    return (
      <div className="flex h-24 items-center justify-center border-t border-line-subtle">
        <Spinner size={4} />
      </div>
    );
  }

  return (
    <div className="border-t border-line-subtle">
      {/* Above the log rather than in it: the reason a start failed is a sentence the sidecar
          already worked out ("exited immediately", "EADDRINUSE"), and burying it in the tail
          leaves the reader to re-derive it from the output. */}
      {error && (
        <p className="border-b border-line-subtle bg-danger-tint px-3 py-2 font-mono text-2xs whitespace-pre-wrap text-danger">
          {error}
        </p>
      )}
      <pre className="max-h-48 overflow-auto bg-surface-2 px-3 py-2 font-mono text-2xs whitespace-pre-wrap text-fg-secondary">
        {logs.trim() || 'Nothing logged yet.'}
      </pre>
    </div>
  );
}
